import React, { useEffect, useState } from "react";
import Header from "../../component/menu/Header";
import CustomLoader from "../../component/menu/CustomLoader";
import { SettingOutlined } from "@ant-design/icons";
import Settings from "../../component/settings/Settings";
import { getParentRestaurantDropdown } from "../../services/user-service";
import useUserStore from "../../stores/store";

function SettingsSuperAdmin() {
  const [parentRestaurantList, setParentRestaurantList] = useState([]);
  const {user, setNetworkCall} = useUserStore();

  useEffect(() => {
    (async () => {
      setNetworkCall(true);
      const records = await getParentRestaurantDropdown({}, user.token.token);
      
      setParentRestaurantList(records);
      setNetworkCall(false);
    })();
  }, []);

  return (
    <div className="flex flex-col">
      <CustomLoader />
      <Header title={"Settings"} />
      <div className="flex flex-col p-[24px] w-full mt-[80px] font-uregular">
        <div className="w-[80%] m-auto bg-white">
          <div className="p-5">
            <div className="w-full font-bold mb-10 ">
              <SettingOutlined style={{ fontSize: 16, marginRight: 10 }} />
              Settings
            </div>
            <div>
              <Settings parentRestaurantList={parentRestaurantList}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SettingsSuperAdmin;
